<div class="auth-page">
  <div class="ambient-glow"></div>

  <!-- Animated trading background -->
  <div class="trading-bg" aria-hidden="true">
    <div class="candles-row">
      <div class="candle-bar" style="height:20%;animation-delay:0.2s"></div>
      <div class="candle-bar" style="height:35%;animation-delay:0.5s"></div>
      <div class="candle-bar" style="height:25%;animation-delay:0.8s"></div>
      <div class="candle-bar" style="height:45%;animation-delay:1.1s"></div>
      <div class="candle-bar" style="height:40%;animation-delay:1.4s"></div>
      <div class="candle-bar" style="height:60%;animation-delay:1.7s"></div>
      <div class="candle-bar" style="height:55%;animation-delay:2.0s"></div>
      <div class="candle-bar" style="height:75%;animation-delay:2.3s"></div>
      <div class="candle-bar" style="height:70%;animation-delay:2.6s"></div>
      <div class="candle-bar" style="height:90%;animation-delay:2.9s"></div>
    </div>
    <svg class="chart-svg" preserveAspectRatio="none" viewBox="0 0 1000 1000">
      <defs>
        <filter id="login-glow">
          <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
          <feMerge><feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
      </defs>
      <path class="chart-line"
        d="M0,900 L100,850 L200,880 L300,750 L400,780 L500,600 L600,650 L700,450 L800,500 L900,200 L1000,250"
        fill="none" stroke-width="3" filter="url(#login-glow)"/>
    </svg>
  </div>

  <div class="theme-toggle-btn" (click)="toggleTheme()" [title]="themeService.isDark() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
    <span class="material-symbols-outlined">{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</span>
  </div>

  <div class="auth-container">
    <div class="auth-logo">
      <img src="assets/img/logo-icon.png" alt="Nectum" class="logo-img" />
      <span class="logo-text">Nectum Investment <sup class="logo-reg">®</sup></span>
    </div>

    <div class="auth-card">
      <div class="card-header">
        <h2>Iniciar sesión</h2>
       
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <div class="form-field">
          <label for="email" class="field-label">Correo electrónico</label>
          <div class="input-wrapper">
            <span class="material-symbols-outlined field-icon">mail</span>
            <input
              type="email"
              id="email"
              formControlName="email"
              placeholder="tu@empresa.com"
              class="field-input"
            />
          </div>
        </div>

        <div class="form-field">
          <div class="field-row">
            <label for="password" class="field-label">Contraseña</label>
            <a href="javascript:void(0)" (click)="openForgotPassword()" class="forgot-link">
              ¿Olvidaste tu contraseña?
            </a>
          </div>
          <div class="input-wrapper">
            <span class="material-symbols-outlined field-icon">lock</span>
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              placeholder="••••••••"
              class="field-input has-toggle"
            />
            <button type="button" class="toggle-btn" (click)="togglePassword()">
              <span class="material-symbols-outlined">{{ showPassword ? 'visibility' : 'visibility_off' }}</span>
            </button>
          </div>
        </div>

        <div class="remember-row">
          <mat-checkbox (change)="Recordar($event)">Recordar sesión</mat-checkbox>
        </div>

        <button type="submit" class="submit-btn" [disabled]="isLoading">
          <span *ngIf="!isLoading">Iniciar Sesión</span>
          <mat-spinner *ngIf="isLoading" diameter="20" color="accent"></mat-spinner>
        </button>
      </form>

      <div class="card-footer">
        <p>¿No tienes cuenta?
          <a href="https://nectum-investment.com/" target="_blank" class="register-link">Regístrate ahora</a>
        </p>
      </div>
    </div>
  </div>
</div>
